import 'bootstrap';
import './components/carousel';
import './components/fade-up-animation';
import './components/scroll-mask';
import { initCardScroll } from './components/card-scroll';
import { initStickyNav } from './components/sticky-nav';
import '../scss/style.scss';
document.addEventListener('DOMContentLoaded', () => {
    initCardScroll();
    initStickyNav();
});
